module.exports = __webpack_public_path__ + "img/alumco.17e4de56.png";